import * as types from "../mutation-types";

const state = {
    notification: {
        visible: false,
        size: "small",
        variation: "informational",
        title: "Title",
        persistent: false,
        text: "Default text",
        duration: 3000 // milliseconds
    },
    notificationStack: {
        visible: false,
        stack: []
    },
    hypoList: [],
    hypoCount: 0
};

const getters = {
    getHypoCount(state) {
        return state.hypoCount;
    },
    getHypoList(state) {
        return state.hypoList;
    }
};
const actions = {
    showNotification({ commit }, data) {
        commit(types.SHOW_NOTIFICATION, data);
    },
    showNotificationStack({ commit }, data) {
        commit(types.SHOW_NOTIFICATION_STACK, data);
    },
    clearNotification({ commit }) {
        commit(types.DISMISS_NOTIFICATION, false);
        commit(types.CLEAR_NOTIFICATION);
    },
    clearStackedNotification({ commit }, data) {
        commit(types.CLEAR_STACKED_NOTIFICATION, data);
    },
    setHypoCount({ commit }, data) {
        commit(types.SET_HYPO_COUNT, data);
    },
    setHypoList({ commit }, data) {
        commit(types.SET_HYPO_LIST, data);
    }
};
const mutations = {
    [types.DISMISS_NOTIFICATION](state) {
        state.notification.visible = false;
    },
    [types.SHOW_NOTIFICATION](state, data) {
        state.notification = {
            visible: true,
            duration: data.duration || 3000,
            ...data
        };
    },
    [types.SHOW_NOTIFICATION_STACK](state, data) {
        state.notificationStack = {
            visible: true,
            stack: data
        };
    },
    [types.CLEAR_NOTIFICATION](state) {
        state.notification = {
            visible: false,
            size: "small",
            variation: "informational",
            title: "Title",
            persistent: false,
            text: "Default text",
            duration: 3000
        };
    },
    [types.CLEAR_NOTIFICATION_STACK](state) {
        state.notificationStack = {
            visible: false,
            stack: []
        };
    },
    [types.CLEAR_STACKED_NOTIFICATION](state, data) {
        const updatedStack = { ...state.notificationStack };
        updatedStack.stack = state.notificationStack.stack.filter(item => item.key !== data);
        state.notificationStack = updatedStack;
    },
    [types.SET_HYPO_COUNT](state, data) {
        state.hypoCount = data;
    },
    [types.SET_HYPO_LIST](state, data) {
        state.hypoList = data;
    }
};

export default {
    state,
    actions,
    getters,
    mutations
};
